import { TranslateWithPluralize } from '@marketplace-web/i18n/i18n-data'
import { BumpOptionsModel } from '@marketplace-web/vas/vas-data'

type Props = {
  bumpOptions: BumpOptionsModel
  orderItemsCount: number
  translate: TranslateWithPluralize
}

export const generateBumpMotivationText = ({ bumpOptions, orderItemsCount, translate }: Props) => {
  const { freeBumpsCount, bumpableItemCount, discountPercentage, multiBumpDiscount } = bumpOptions

  if (discountPercentage > 0) {
    if (freeBumpsCount === 0) {
      return translate('motivation.discount', { count: discountPercentage })
    }
    if (freeBumpsCount > 0) {
      if (orderItemsCount > freeBumpsCount) {
        return translate(
          'motivation.free_bump_and_discount',
          { count: freeBumpsCount, discount: discountPercentage },
          { count: freeBumpsCount },
        )
      }
      if (orderItemsCount === freeBumpsCount) {
        return `${translate(
          'motivation.free_bump',
          { count: freeBumpsCount },
          { count: freeBumpsCount },
        )}, ${translate('motivation.remaining_discount', { count: discountPercentage })}`
      }
      if (orderItemsCount < freeBumpsCount) {
        const remainingFreeBumps = freeBumpsCount - orderItemsCount

        return `${translate(
          'motivation.free_bump',
          { count: orderItemsCount },
          { count: orderItemsCount },
        )}, 
            ${translate(
              'motivation.remaining_free_bump_and_discount',
              { count: remainingFreeBumps, discount: discountPercentage },
              { count: remainingFreeBumps },
            )}`
      }
    }
  }

  if (discountPercentage === 0) {
    const isEligibleForMultiBumpDiscount =
      bumpableItemCount - freeBumpsCount >= multiBumpDiscount.minPaidItemCount
    if (isEligibleForMultiBumpDiscount) {
      if (freeBumpsCount === 0) {
        return translate('motivation.multi_bump_discount')
      }
      if (orderItemsCount >= freeBumpsCount) {
        return `${translate(
          'motivation.free_bump',
          { count: freeBumpsCount },
          { count: freeBumpsCount },
        )}, ${translate('motivation.multi_bump_discount')}`
      }
      if (orderItemsCount < freeBumpsCount) {
        const remainingFreeBumps = freeBumpsCount - orderItemsCount

        return `${translate(
          'motivation.free_bump',
          { count: orderItemsCount },
          { count: orderItemsCount },
        )}, ${translate(
          'motivation.remaining_free_bump',
          { count: remainingFreeBumps },
          { count: remainingFreeBumps },
        )} + ${translate('motivation.multi_bump_discount')}`
      }
    }
    if (freeBumpsCount === 0) {
      return null
    }
    if (orderItemsCount >= freeBumpsCount) {
      return translate('motivation.free_bump', { count: freeBumpsCount }, { count: freeBumpsCount })
    }
    if (orderItemsCount < freeBumpsCount) {
      const remainingFreeBumps = freeBumpsCount - orderItemsCount

      return `${translate(
        'motivation.free_bump',
        { count: orderItemsCount },
        { count: orderItemsCount },
      )}, ${translate(
        'motivation.remaining_free_bump',
        { count: remainingFreeBumps },
        { count: remainingFreeBumps },
      )}`
    }
  }

  return null
}
